import { useAuth } from '@mezzodevelopment/mezzo-ui/auth';
import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';

interface SecureRouteProps {
  children: ReactNode;
  scopes?: string[];
}

const Loader = () => (
  <div className="flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
    <span className="ml-2">Loading permissions...</span>
  </div>
);

function SecureRoute({ children, scopes }: SecureRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <Loader />;
  if (!user) return <Navigate to={`/login?returnUrl=${encodeURIComponent(location.pathname)}`} />;
  // TODO: create scope context
  if (scopes && (!user.roles || !scopes.some((g) => user.roles.includes(g)))) {
    return <Navigate to="/401" />;
  }
  return children;
}

export default SecureRoute;
